import { IConfig } from '@cian/config/shared';

const BANNER_URL_CONFIG_KEY = 'mortgage-calculator.cianMortgageBannerUrl';

export const getCianMortgageBannerUrl = (config: IConfig): string => {
  return config.getStrict<string>(BANNER_URL_CONFIG_KEY);
};
